import '../CSS/Estilo.css'


export default function MenuDesplegable({opciones,opcionesOnClick})
{
    return(        
    <div className="dropdown">
        <button className="dropbtn">Estilo</button>
        <div className="dropdown-content">
            {opciones.map((opcion) =>(
                <a href="#" key={opcion} id={opcion} onClick={opcionesOnClick}>{opcion}</a>
            ))}           
        </div>
  </div>
    )    
}

